// Phase 3 App-Root. BrowserRouter mit allen Routen aus mockups/03-shell/approved.md.
// Public Routes (login/signup/recover) sind frei; alles unter / läuft durch AuthGate
// und ist in AppShell eingebettet.

import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { AuthGate } from './components/auth-gate';
import { FeatureGate } from './components/feature-gate';
import { AppShell } from './components/shell/app-shell';
import { LoginPage } from './pages/login';
import { SignupPage } from './pages/signup';
import { RecoverPage } from './pages/recover';
import { MarktPage } from './pages/markt';
import { PolymarketPage } from './pages/polymarket';
import { TrendingPage } from './pages/trending';
import { AdminPage } from './pages/admin';
import { CallsPage } from './pages/calls';
import { HyperliquidPage } from './pages/hyperliquid';
import { JapanCarryPage } from './pages/japan-carry';
import { MemoryPage } from './pages/memory';
import { RasPage } from './pages/ras';
import { TradingMacroPage } from './pages/trading-macro';
import { PrivatPage } from './pages/privat';
import { CreditsPage } from './pages/credits';
import { CoachingPage } from './pages/coaching';
import { CommunityPage } from './pages/community';
import AcademyPage from './pages/academy';
import { SettingsPage } from './pages/settings';

export function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* Public */}
        <Route path="/login" element={<LoginPage />} />
        <Route path="/signup" element={<SignupPage />} />
        <Route path="/recover" element={<RecoverPage />} />

        {/* Protected */}
        <Route
          path="/"
          element={
            <AuthGate>
              <AppShell />
            </AuthGate>
          }
        >
          <Route index element={<Navigate to="/markt" replace />} />
          <Route
            path="markt"
            element={
              <FeatureGate feature="markt">
                <MarktPage />
              </FeatureGate>
            }
          />
          <Route
            path="markt/polymarket"
            element={
              <FeatureGate feature="markt">
                <PolymarketPage />
              </FeatureGate>
            }
          />
          <Route
            path="markt/trending"
            element={
              <FeatureGate feature="markt">
                <TrendingPage />
              </FeatureGate>
            }
          />
          <Route
            path="markt/japan-carry"
            element={
              <FeatureGate feature="markt">
                <JapanCarryPage />
              </FeatureGate>
            }
          />
          <Route
            path="trading/macro"
            element={
              <FeatureGate feature="trading">
                <TradingMacroPage />
              </FeatureGate>
            }
          />
          <Route
            path="hyperliquid"
            element={
              <FeatureGate feature="hyperliquid">
                <HyperliquidPage />
              </FeatureGate>
            }
          />
          <Route
            path="academy"
            element={
              <FeatureGate feature="academy">
                <AcademyPage />
              </FeatureGate>
            }
          />
          <Route
            path="coaching"
            element={
              <FeatureGate feature="coaching">
                <CoachingPage />
              </FeatureGate>
            }
          />
          <Route
            path="community"
            element={
              <FeatureGate feature="community">
                <CommunityPage />
              </FeatureGate>
            }
          />
          <Route
            path="privat"
            element={
              <FeatureGate feature="privat">
                <PrivatPage />
              </FeatureGate>
            }
          />
          <Route path="admin" element={<AdminPage />} />
          <Route path="credits" element={<CreditsPage />} />
          <Route path="memory" element={<MemoryPage />} />
          <Route path="ras" element={<RasPage />} />
          <Route path="calls" element={<CallsPage />} />
          <Route path="settings" element={<SettingsPage />} />
        </Route>

        {/* Fallback */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}
